export interface BonusItem {
  label: string
  title: string
  bullets?: string[]
  paragraphs: string[]
  value?: string
  image: string
}

export const bonusItems: BonusItem[] = [
  {
    label: 'Bono 1',
    title: 'Modo Parcial: 6 simulacros de contabilidad',
    paragraphs: ['Poné a prueba tus conocimientos con seis simulacros para resolver y corregir.'],
    value: '$9500',
    image: 'https://cdn.magicpatterns.com/uploads/qKg6oaDToeNnwJk7FBshTZ/bono1_(2).png',
  },
  {
    label: 'Bono 2',
    title: 'Contabilidad en Excel',
    bullets: ['Plantilla de Excel para completar.', 'Guía con consignas, datos y operaciones.', 'Archivo de ejemplo resuelto para comparar.'],
    paragraphs: ['Empezá por la guía, completá el Excel y después revisá el ejemplo resuelto.'],
    value: '$11000',
    image: 'https://cdn.magicpatterns.com/uploads/e6d6rYtYFAyjVL52ZhVjjR/bono2_(2).png',
  },
  {
    label: 'Bono 3',
    title: 'Detective contable: encontrá y corregí 40 errores',
    paragraphs: ['Resolvé 40 casos y contrastá tu análisis con las soluciones del material.'],
    value: '$7600',
    image: 'https://cdn.magicpatterns.com/uploads/qsZWZp1cUsQ3THr1JMnPTe/bono3_(2).png',
  },
  {
    label: 'Bono 4',
    title: 'Contabilidad en práctica: 50 ejercicios para resolver',
    paragraphs: ['Ideal para incorporar una instancia de práctica después del repaso.', 'Incluido con tu MegaPack.'],
    value: '$12400',
    image: 'https://cdn.magicpatterns.com/uploads/3DKP5XKkc9PXxVijj1hBuU/bono4.png',
  },
  {
    label: 'Bono 5',
    title: 'Del comprobante al asiento: 30 documentos para practicar',
    paragraphs: ['Identificá qué ocurrió, relacioná los comprobantes y completá los asientos y saldos.', 'Al final encontrás las respuestas y sus explicaciones para comparar tu trabajo.'],
    value: '$8200',
    image: 'https://cdn.magicpatterns.com/uploads/wikLbSJkhJqBmPxPd9Pa8h/bono5.png',
  },
]
